<template>
  <div>
    <v-chip v-for="tag in filterTags" :key="tag" close @input="toggleTag(tag)">
      {{ tag }}
    </v-chip>
  </div>
</template>

<script>
import { TOGGLE_TAG } from "@/action-types";

export default {
  name: "RecipeFilterChips",
  computed: {
    filter() {
      return this.$store.state.filter;
    },
    filterTags() {
      return this.filter.tags;
    }
  },
  methods: {
    toggleTag(tag) {
      this.$store.commit(TOGGLE_TAG, tag);
    }
  }
};
</script>
